module.exports = __webpack_public_path__ + "static/media/1014599.b40e3a59.jpg";